import React from 'react';
import { ShadedBox } from '../../Common/ShadedBox';
import { PlanUsage } from '~/types/models';
import { HorizontalDivider } from '../../Common/HorizontalDivider';
import { FeaturesGridList } from './FeaturesGridList';
import { PlanDescription } from './Description';
import { UsagesList } from './UsagesList';

export interface PlanProductCardProps {
  iconImgUrl?: string;
  imgUrl?: string;
  title?: string;
  discountFormat?: string;
  planDescription?: string;
  billingPrice?: string;
  billingDescription?: string;
  featuresList?: string[];
  usages?: PlanUsage[];
}

export function PlanProductCard({
  iconImgUrl,
  imgUrl,
  title,
  discountFormat,
  planDescription,
  billingPrice,
  billingDescription,
  featuresList,
  usages,
}: PlanProductCardProps) {
  return (
    <ShadedBox className='block h-full relative'>
      {iconImgUrl && (
        <img
          src={iconImgUrl}
          className='w-[35px] h-[35px] absolute top-4 left-4 p-1 rounded border border-solid v2-border-neutral-300'
        />
      )}
      <div className='flex flex-col lg:flex-row gap-x-4 gap-y-8 justify-center items-center'>
        <PlanDescription
          imgUrl={imgUrl}
          title={title}
          discountFormat={discountFormat}
          planDescription={planDescription}
          billingPrice={billingPrice}
          billingDescription={billingDescription}
        />
        <FeaturesGridList featuresList={featuresList} />
      </div>
      <HorizontalDivider />
      <UsagesList usages={usages} />
    </ShadedBox>
  );
}
